import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { EmployeeLayout } from './components/EmployeeLayout';
import { AdminLayout } from './components/AdminLayout';
import { LoginPage } from './pages/LoginPage';
import { EmployeeDashboard } from './pages/EmployeeDashboard';
import { EmployeeAlerts } from './pages/EmployeeAlerts';
import { EmployeeSessions } from './pages/EmployeeSessions';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminEmployeeDetail } from './pages/AdminEmployeeDetail';
import { AdminVideoUpload } from './pages/AdminVideoUpload';
import { AdminCubicleConfig } from './pages/AdminCubicleConfig';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          {/* Employee Routes */}
          <Route path="/employee" element={
            <ProtectedRoute requiredRole="employee">
              <EmployeeLayout />
            </ProtectedRoute>
          }>
            <Route index element={<EmployeeDashboard />} />
            <Route path="alerts" element={<EmployeeAlerts />} />
            <Route path="sessions" element={<EmployeeSessions />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute requiredRole="admin">
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="employee/:employeeId" element={<AdminEmployeeDetail />} />
            <Route path="upload" element={<AdminVideoUpload />} />
            <Route path="cubicles" element={<AdminCubicleConfig />} />
          </Route>
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
